import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class UrlService {
    public createRouteUrl(location: string): string {
        const trimmedLocation = this.trimLeadingSlash(location);
        return trimmedLocation;
    }

    public createApiUrl(location: string): string {
        const trimmedLocation: string = this.trimLeadingSlash(location);
        return environment.ideaApiUrl + trimmedLocation;
    }

    private trimLeadingSlash(location: string): string {
        const regex = /^\//;
        return location.replace(regex, '');
    }
}
